"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Passport 域名
 */
const DOMAINS = {
    local: {
        cn: {
            page: 'http://ppl.makeblock.com:8082/passport/index.html#/',
            api: 'https://passport-api-dev.makeblock.com/v1'
        },
        intl: {
            page: 'http://ppl.mblock.cc:8082/passport/index.html#/',
            api: 'https://passport-api-dev.mblock.cc/v1'
        }
    },
    dev: {
        cn: {
            page: '//dev-web.makeblock.com/passport/index.html#/',
            api: '//passport-api-dev.makeblock.com/v1'
        },
        intl: {
            page: '//dev-web.mblock.cc/passport/index.html#/',
            api: '//passport-api-dev.mblock.cc/v1'
        }
    },
    test: {
        cn: {
            page: 'https://test-web.makeblock.com/passport/index.html#/',
            api: 'https://passport-api-test.makeblock.com/v1'
        },
        intl: {
            page: 'https://test-web.mblock.cc/passport/index.html#/',
            api: 'https://passport-api-test.mblock.cc/v1'
        }
    },
    prod: {
        cn: {
            page: 'https://passport.makeblock.com/#/',
            api: 'https://passport-api.makeblock.com/v1'
        },
        intl: {
            page: 'https://passport.mblock.cc/#/',
            api: 'https://passport-api.mblock.cc/v1'
        }
    }
};
exports.default = DOMAINS;
